import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F0E8]">
        <Loader2 className="w-10 h-10 animate-spin text-emerald-700" />
      </div>
    );
  }
  if (user === false) {
    // Après connexion, on revient à la voix scannée depuis le livret.
    const back = location.pathname.startsWith("/ecouter/") ? `?retour=${encodeURIComponent(location.pathname)}` : "";
    return <Navigate to={`/connexion${back}`} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    // Familles redirigées vers leur espace, autres vers le hub
    return <Navigate to={user.space === "residence" ? "/nouvelles" : user.role === "family" ? "/famille" : "/espaces"} replace />;
  }
  return children;
}
